export default "__VITE_ASSET__MxvcPbpx__"